import { useMemo, useState } from 'react';
import { secretWords } from '../constants';
import { encryptionSets } from '../constants/encryption-sets'
import { shakeAndBangSets } from '../constants/shake-and-band-sets';
import { getQuickEncryptionConfig } from '../lib/cryptic';
import { QuickEncryptionConfig } from '../components/settings/QuickEncryptionConfig';
import { useGetter } from 'vuex-react';

export const Settings = () => {
  const getQuickEncryption = () => getQuickEncryptionConfig('array')
  const updateSetting = (settingName, event) => {
    const value = event.target.value
    localStorage.setItem(settingName, value)

    setEncryptionConfig(getQuickEncryption())
  }

  const [encryptionConfig, setEncryptionConfig] = useGetter('encryptionConfig/config');

  const [
    currentSecretWord,
    currentEncryptionSet,
    currentShakeAndBangSet
  ] = useMemo(() => ([
    localStorage.getItem('SECRET_WORD') || secretWords[0],
    localStorage.getItem('ENCRYPTION_SET') || encryptionSets[0].name,
    localStorage.getItem('SHAKE_AND_BANG_SET') || shakeAndBangSets[0].name
  ]), [encryptionConfig]);

  return (
    <div className="settings-page">
      <h3 className="page-title">Settings</h3>

      <QuickEncryptionConfig />

      <div className="settings-item">
        <label htmlFor="secret-word-select">Secret words</label>
        <select
          id="secret-word-select"
          name="shake-and-bang-set"
          value={currentSecretWord}
          defaultValue={currentSecretWord}
          onChange={(e) => updateSetting('SECRET_WORD', e)}
        >
          {secretWords.map((secretWord) => (
            <option
              key={secretWord}
              value={secretWord}
            >
              {secretWord}
            </option>
          ))}
        </select>
      </div>

      <div className="settings-item">
        <label htmlFor="encryption-set">Encryption set</label>
        <select
          id="encryption-set"
          name="encryption-set"
          defaultValue={currentEncryptionSet}
          value={currentEncryptionSet}
          onChange={(e) => updateSetting('ENCRYPTION_SET', e)}
        >
          {encryptionSets.map((set) => (
            <option
              key={set.name}
              value={set.name}
            >
              {set.name}
            </option>
          ))}
        </select>
      </div>

      <div className="settings-item">
        <label htmlFor="shake-and-bang-set">Shake and Bang set</label>
        <select
          id="shake-and-bang-set"
          name="shake-and-bang-set"
          defaultValue={currentShakeAndBangSet}
          value={currentShakeAndBangSet}
          onChange={(e) => updateSetting('SHAKE_AND_BANG_SET', e)}
        >
          {shakeAndBangSets.map((set) => (
            <option
              key={set.name}
              value={set.name}
            >
              {set.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}